import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { SYSTEM_FAILURE_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { SYSTEM_FAILURE_REPORT } from "../interfaces/dashboard";

export default function SystemFailure() {
    const systemFailureReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.SYSTEM_FAILURE_REPORT;

    const [systemFailureReportTableData, setSystemFailureReportTableData] = useState<SYSTEM_FAILURE_REPORT[]>([]);

    useEffect(() => {
        setSystemFailureReportTableData(SYSTEM_FAILURE_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType='SYSTEM_FAILURE'
        tableColumns={systemFailureReportTableColumns}
        tableData={systemFailureReportTableData} />
    );
}